<form [formGroup]="newAddressForm" class="address-update-form" style="width: 100%;">

  <div class="form-header" style="padding-bottom: 50px;">
    <strong>{{'CUSTOMER.FORM.ADDRESS' | translate}}</strong> : {{'CUSTOMER.FORM.NOADDRESESFOUNDTIP' | translate}}
  </div>

  <div style="display: flex; flex-direction: column; align-items: stretch; width: 100%;">

    <div style="display: flex; flex-direction: row; align-items: center; gap: 25px; padding-bottom: 25px; width: 100%;">
      <!-- Street / autocomplete -->
      <p-floatLabel>
        <p-autoComplete ngClass="p-fluid" [style]="{'width':'20vw'}" [inputStyle]="{'width':'20vw'}" inputId="street" formControlName="street" [suggestions]="foundAddresses" 
        (completeMethod)="searchAddress($event)" (onSelect)="setAddress($event.value)" (onClear)="clearAddress()" [field]="'street'" [dropdown]="false" [forceSelection]="false" [showClear]="false">
          <ng-template let-address pTemplate="item">
            <div>
              <strong>{{ formattedStreetName(address) }}</strong>
              <small> {{ address.zipCode }} {{ address.city }}
                <span *ngIf="address.countryCode">, {{ address.countryCode }}</span>
              </small>
            </div>
          </ng-template>
        </p-autoComplete>
        <label>{{'CUSTOMER.FORM.ADDRESS' | translate}}</label>
        <small *ngIf="!newAddressForm.get('street').valid">{{'CUSTOMER.FORM.ERROR.street' |translate}}</small>
      </p-floatLabel>

      <!-- Street 2 -->
      <p-floatLabel>
        <input style="width: 20vw" id="street2" type="text" pInputText formControlName="street2" placeholder="Apartment, floor, suite, etc." />
        <label for="street2">{{'CUSTOMER.FORM.STREETTWO' | translate}}</label>
      </p-floatLabel>
    </div>

    <hr style="padding-bottom: 25px;">

    <div style="display: flex; flex-direction: row; gap: 25px; padding-bottom: 25px;">
      <!-- City -->
      <p-floatLabel>
        <input style="min-width: 25%;" id="city" type="text" pInputText formControlName="city" placeholder="City" />
        <label for="city">{{'CITY' | translate}}</label>
        <small *ngIf="!newAddressForm.get('city').valid && newAddressForm.get('city').touched">{{'CUSTOMER.FORM.ERROR.CITY' |translate}}</small>
      </p-floatLabel>


      <!-- Zip code -->
      <p-floatLabel>
        <input style="min-width: 25%;" id="zipCode" type="text" pInputText formControlName="zipCode" placeholder="Zip code" />
        <label for="zipCode">{{'ZIPCODE' | translate}}</label>
        <small *ngIf="!newAddressForm.get('zipCode').valid && newAddressForm.get('zipCode').touched">{{'CUSTOMER.FORM.ERROR.ZIPCODE' |translate}}</small>
      </p-floatLabel>

      <!-- Country -->
      <p-floatLabel>
        <input pInputText style="min-width: 25%;" inputId="countryCode" formControlName="countryCode" />
        <label for="countryCode">{{'COUNTRY' | translate}}</label>
      </p-floatLabel>

    </div>

    <!-- 
    <div style="display: flex; flex-direction: row; gap: 25px; padding-bottom: 25px;">


      Latitude -->
    <!-- <p-floatLabel>
        <input style="min-width: 25%;" id="latitude" type="number" pInputText formControlName="latitude" placeholder="Latitude" readonly />
        <label for="latitude">{{'latitude' | translate}}</label>
      </p-floatLabel> -->

    <!-- Longitude -->
    <!-- <p-floatLabel>
        <input style="min-width: 25%;" id="longitude" type="number" pInputText formControlName="longitude" placeholder="Longitude" readonly />
        <label for="longitude">{{'longitude' | translate}}</label>
      </p-floatLabel> 
      
    </div>
    -->

  </div>
  <div style="display: flex; flex-direction: row; justify-content: space-between; padding-top: 25px;">
    <!-- <button pButton type="button" label="Clear" icon="pi pi-trash" severity="secondary" outlined="true" (click)="onClearAddress()"></button> -->
    <button pButton type="button" [label]="'GENERIC.CANCEL' |translate" icon="pi pi-times" severity="secondary" text="true" (click)="ref.close()"></button>
    <button pButton type="button" (click)="addAddress()" [disabled]="newAddressForm.invalid"><i class="pi pi-check" style="margin-right: 5px;"></i> {{'CUSTOMER.FORM.UPDATEADDRESE' | translate}}</button>
  </div>
</form>